import { render } from "./AddMenu.vue?vue&type=template&id=96da35c4&scoped=true&ts=true"
import script from "./AddMenu.vue?vue&type=script&lang=ts"
export * from "./AddMenu.vue?vue&type=script&lang=ts"

import "./AddMenu.vue?vue&type=style&index=0&id=96da35c4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96da35c4"]])

export default __exports__